<template>
  <QScrollArea
    v-if="announcementStore.data?.length > 0"
    class="h-68 rounded-lg"
  >
    <div class="min-h-16 bg-dark-3 p-5 flex gap-5">
      <RouterLink
        v-for="announcement in announcementStore.data"
        :to="{name: 'announcements.show', params: {announcement: announcement.id}}"
        class="w-full bg-dark-1 rounded-lg p-3 flex flex-nowrap items-center gap-5 divide-x divide-dark-3 hover:(border border-[#27C8E5] divide-[#27C8E5])"
      >
        <SvgIcon
          name="announcements"
          size="30px"
        />
        <div class="w-full flex flex-nowrap justify-between pl-5">
          <div class="flex flex-col gap-2 col-span-5">
            <div class="font-bold grid">
              <span class="truncate">{{ announcement.title }}</span>
            </div>
            <div class="grid flex-1">
              <span class="text-[#999999] truncate">{{
                getHtmlText(announcement.content).length <= 0 ? '&nbsp;' : getHtmlText(announcement.content)
              }}</span>
            </div>
          </div>
          <div class="flex items-center justify-end text-[#999999] whitespace-nowrap">
            {{ dayjs(announcement.published_at).format('YYYY-MM-DD') }}
          </div>
        </div>
      </RouterLink>
    </div>
  </QScrollArea>
  <div
    v-else
    class="h-70 rounded-lg bg-dark-3"
  />
</template>

<script setup>
import { dayjs, getHtmlText } from '@/utils/index.js'
import { useAnnouncementStore } from '@/stores/announcement.js'
import SvgIcon from "@/components/Icons/SvgIcon.vue";

const announcementStore = useAnnouncementStore()
announcementStore.fetch()
</script>
